export type PremiumServiceKey = 'apis' | 'edge' | 'pro' | 'research' | 'services';

export interface PremiumServiceAccess {
  hasEdge: boolean;
  hasPro: boolean;
  hasResearch: boolean;
}

const UTM = 'utm_campaign=premium-services-dropdown&utm_ad_type=navbar';

export const PREMIUM_SERVICE_LINKS: Record<PremiumServiceKey, { marketing: string; product?: string }> = {
  apis: {
    marketing: `https://www.benzinga.com/apis/?${UTM}`,
  },
  edge: {
    marketing: `https://www.benzinga.com/premium/ideas/benzinga-edge-4?${UTM}`,
    product: 'https://www.benzinga.com/edge/dashboard',
  },
  pro: {
    marketing: `https://www.benzinga.com/pro/pricing?${UTM}`,
    product: 'https://pro.benzinga.com/',
  },
  research: {
    marketing: `https://www.benzinga.com/research/trade-alerts?${UTM}`,
    product: 'https://www.benzinga.com/research',
  },
  services: {
    marketing:
      'https://www.benzinga.com/services?utm_medium=button&utm_campaign=premium-services&utm_ad_type=nav-bar&utm_id=big-blue-button',
  },
};

export const getPremiumServiceHref = (service: PremiumServiceKey, access: PremiumServiceAccess): string => {
  const links = PREMIUM_SERVICE_LINKS[service];

  if (service === 'apis' || !links.product) {
    return links.marketing;
  }

  const hasAccess = service === 'edge' ? access.hasEdge : service === 'pro' ? access.hasPro : access.hasResearch;

  return hasAccess ? links.product : links.marketing;
};

export type NavMenuItemHrefInput = {
  href?: string;
  logged_in_href?: string;
  premium_service?: PremiumServiceKey;
};

export const getNavMenuItemHref = (
  item: NavMenuItemHrefInput,
  isLoggedIn: boolean,
  access: PremiumServiceAccess,
): string => {
  if (item.premium_service) {
    return getPremiumServiceHref(item.premium_service, access);
  }

  if (isLoggedIn && item.logged_in_href) {
    return item.logged_in_href;
  }

  return item.href ?? '#';
};
